import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#ffffff",
    padding: "50px",
  },
  header: {
    fontSize: "24",
    display: "flex",
    flexDirection: "row",
    // margin: "0px 50px 10px 50px",
    borderBottom: "2pt solid black",
  },
  words: {
    margin: "5px",
  },
  word1: {
    margin: "5px",
    width: "70%",
  },
  word2: {
    margin: "5px",
    width: "10%",
    textAlign: "right",
  },
  word3: {
    margin: "5px",
    width: "20%",
  },
  section: {
    borderBottom: "1pt dashed black",
    margin: "0px 20px",
    paddingBottom: "5px",
    display: "flex",
    flexDirection: "column",
  },
  section2: {
    fontSize: "14",
    // margin: "0px 52px",
    display: "flex",
    flexDirection: "row",
  },
  item1: {
    marginLeft: "25px",
    fontSize: "12",
    fontWeight: "200",
    width: "140px",
  },
  item2: {
    marginLeft: "25px",
    fontSize: "12",
    width: "30px",
    fontWeight: "200",
    textAlign: "right",
  },
  item3: {
    marginLeft: "5px",
    fontSize: "12",
    width: "90px",
    fontWeight: "200",
  },
});

function sortByThenBy(a, b, thenBy, order) {
  if (order === "asc" || !order) {
    if (!a && !b) return thenBy || 0;
    if (!a) return -1;
    if (!b) return +1;

    return a.localeCompare(b) || thenBy || 0;
  } else if (order === "desc") {
    if (!a && !b) return thenBy || 0;
    if (!a) return +1;
    if (!b) return -1;

    return b.localeCompare(a) || thenBy || 0;
  }
}

export default function Report({ orderedProducts, sheet, fromDate }) {
  return (
    <Document>
      <Page size="LETTER" style={styles.page}>
        <View fixed style={styles.header}>
          <Text style={styles.words}>{sheet + "s Report"}</Text>
          <Text
            style={{
              fontSize: "12",
              marginLeft: "20px",
              paddingTop: "20px",
            }}
          >
            {fromDate?.toLocaleString()}
          </Text>
        </View>

        {orderedProducts
          ? Object.keys(orderedProducts)
              .sort((a, b) => {
                return sortByThenBy(
                  orderedProducts[a][0].productCategory,
                  orderedProducts[b][0].productCategory,
                  sortByThenBy(
                    orderedProducts[a][0].productSubCategory,
                    orderedProducts[b][0].productSubCategory,
                    sortByThenBy(
                      orderedProducts[a][0].productName,
                      orderedProducts[b][0].productName
                    )
                  )
                );
              })
              .map((key) => {
                // console.log(orderedProducts[key]);
                return (
                  <>
                    <View style={styles.section} wrap={false}>
                      <View style={styles.section2}>
                        <Text style={styles.word1}>
                          {orderedProducts[key][0].groupName ||
                            orderedProducts[key][0].productName}
                        </Text>

                        <Text style={styles.word2}>
                          {orderedProducts[key][0]?.groupName
                            ? orderedProducts[key][0]?.groupQuantity
                            : orderedProducts[key][0]?.quantity}
                        </Text>

                        <Text style={styles.word3}>
                          {`${
                            orderedProducts[key][0].groupUnitOfMeasure ||
                            orderedProducts[key][0].unitOfMeasure
                          }'s`}
                        </Text>
                      </View>
                    </View>
                  </>
                );
              })
          : null}
      </Page>
    </Document>
  );
}
